// The booking drawer's date label: "Jul 08, 2026", sentence case (no forced capitals, Antonin 16 Oct). One helper
// for the time-slots header, the provider selection and the selected-slot summary, so the three can't drift.
const MONTH_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** "Jul 08, 2026" from an ISO date, in local time. */
export function formatSlotDate(iso: string): string {
  const d = new Date(iso);
  return `${MONTH_SHORT[d.getMonth()]} ${String(d.getDate()).padStart(2, '0')}, ${d.getFullYear()}`;
}
